module.exports = __webpack_public_path__ + "static/media/connect-clock-home.30bb37ff.svg";